import React, { Component } from 'react';
import {
  Button, Card, CardBody, Col, Table, Badge, UncontrolledTooltip,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import swal from 'sweetalert';

import CommonService from '../../../services/CommonService';
import global from '../../../global';
import ConfirmDisposeModal from './ConfirmDisposeModal';
import MergeToBatchModal from './MergeToBatchModal';

class ReturnLists extends Component {
   constructor(props) {
      super(props);
      this.state = {
         list: false,
         modal: false,
         formdata: {},
         errorMsg: '',
      };
      this.isLoading = false;
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      this.toggleModal = this.toggleModal.bind(this);
      this.executeModal = '';
   }

   componentDidMount() {
      this.isLoading = true;
      this.onLoadReturns();
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   onLoadReturns = async () => {
      try {
         let location = '';
         if (this.userdata.type !== '1' && this.userdata.type !== '5') {
            location = `/locationid/${this.userdata.location_id}`;
         }
         const response = await CommonService.getRows(`stockreturnlist/type/${this.userdata.type}${location}`);
         if (this.isLoading && response) {
            this.setState({ list: response });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   handleChange = (e, fieldName = '') => {
      if (fieldName === 'number') {
         const { name, value } = e.target;
         this.setState(prevState => ({
           formdata: { ...prevState.formdata, [name]: value.replace(/[^0-9.]/g, '') },
         }));
      } else if (fieldName === 'async') {
         this.setState(prevState => ({
           formdata: { ...prevState.formdata, batchVal: e.value, batchText: e.label },
         }));
      } else {
         const { name, value } = e.target;
         this.setState(prevState => ({
           formdata: { ...prevState.formdata, [name]: value },
         }));
      }
   }

   mergeToggle = (e, returnId, locationTo = 0, product_id = 0) => {
      e.preventDefault();
      this.executeModal = 'mergemodal';
      this.toggleModal();
      this.setState({
         formdata: {
            batchVal: '',
            batchText: '',
            batchLocation: locationTo,
            productid: product_id,
         },
         errorMsg: '',
      });
      this.handleSubmit = (ev) => { this.mergeSubmit(ev, returnId, locationTo); };
   }

   mergeSubmit = async (e, returnId, locationTo) => {
      e.preventDefault();
      const { formdata, list } = this.state;
      formdata.return_id = returnId;
      formdata.status = 1; // 1 - confirm
      formdata.addedBy = this.userdata.user_id;
      formdata.batchLocation = locationTo;

      if (formdata.batchVal) {
         const response = await CommonService.updateData('mergereturntobatch', formdata);
         if (response) {
            if (response === true) {
               list.filter((listResp) => {
                  if (listResp.stock_return_id === formdata.returnId) {
                     listResp.merge_to = formdata.batchText;
                     listResp.status = formdata.status;
                  }
                  return listResp;
               });
               this.setState({
                  list,
                  errorMsg: '',
                  modal: false,
               });
               swal('', 'Successfully merged to batch', 'success');
            } else {
               this.setState({ errorMsg: response, modal: false });
            }
         } else {
            swal('', 'Failed to merge stock to batch', 'warning');
         }
      } else {
         this.setState({ errorMsg: 'Required field is empty.' });
      }
   }

   disposeToggle = (e, returnId) => {
      e.preventDefault();
      this.executeModal = 'disposemodal';
      this.toggleModal();
      this.setState({
         formdata: {
            reason: '',
         },
         errorMsg: '',
      });
      this.handleSubmit = (ev) => { this.disposeSubmit(ev, returnId); };
   }

   disposeSubmit = async (e, returnId) => {
      e.preventDefault();
      const { formdata, list } = this.state;
      formdata.return_id = returnId;
      formdata.status = 3; // 3 - dispose

      if (formdata.reason) {
         const response = await CommonService.updateData('updatereturnstatus', formdata);
         if (response) {
            if (response === true) {
               list.filter((listResp) => {
                  if (listResp.stock_return_id === formdata.returnId) {
                     listResp.status = formdata.status;
                     listResp.disposal_reason = formdata.reason;
                  }
                  return listResp;
               });
               this.setState({
                  list,
                  errorMsg: '',
                  modal: false,
               });
               swal('', 'Successfully disposed stock', 'success');
            } else {
               this.setState({ errorMsg: response, modal: false });
            }
         } else {
            swal('', 'Failed to dispose stock', 'warning');
         }
      } else {
         this.setState({ errorMsg: 'Required field is empty.' });
      }
   }

   toggleModal() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         list, modal, formdata, errorMsg,
      } = this.state;
      const { returnStatus } = global;

      return (
         <Col md={12}>
            {
               this.executeModal === 'disposemodal' ? (
                  <ConfirmDisposeModal
                     modal={modal}
                     toggle={this.toggleModal}
                     handleChange={this.handleChange}
                     postValue={formdata}
                     errorMsg={errorMsg}
                     handleSubmit={this.handleSubmit}
                  />
               ) : this.executeModal === 'mergemodal' ? (
                  <MergeToBatchModal
                     modal={modal}
                     toggle={this.toggleModal}
                     handleChange={this.handleChange}
                     postValue={formdata}
                     errorMsg={errorMsg}
                     handleSubmit={this.handleSubmit}
                  />
               ) : ''
            }
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">STOCK RETURN</h5>
                  </div>
                  <div className="panel__content">
                  <Table responsive striped>
                     <thead className="th-vtop">
                        <tr>
                           <th>Product</th>
                           <th>Location To</th>
                           {
                              (this.userdata.type === '1' && this.userdata.type === '5') && (
                                 <th>Location From</th>
                              )
                           }
                           <th className="text-center">Quantity</th>
                           <th className="text-center" width="15%">Note</th>
                           {
                              this.userdata.type !== '4' && (
                                 <th className="text-center">Merge To <span className="block lh-11 fs-12">( <span className="text-orange">Batch ID</span> )</span></th>
                              )
                           }
                           <th width="10%" className="text-center">Status</th>
                           {
                              this.userdata.type !== '4' && (
                                 <>
                                    <th className="text-center" width="15%">Disposal Reason</th>
                                    <th width="10%" className="text-center">Action</th>
                                 </>
                              )
                           }
                        </tr>
                     </thead>
                     <tbody>
                        {
                           list !== false || list.length > 0 ? list.map((item, i) => {
                              item.status = parseInt(item.status, 10);
                              let badgeColor = 'warning';
                              if (item.status === 1) {
                                 badgeColor = 'success';
                              } else if (item.status === 2 || item.status === 3) {
                                 badgeColor = 'danger';
                              }

                              return (
                                 <tr key={`return_tr${i + 1}`} className="text-center">
                                    <td className="text-left">{item.product_name}</td>
                                    <td className="text-left">{item.location_to_name ? item.location_to_name : '-'}</td>
                                    {
                                       (this.userdata.type === '1' && this.userdata.type === '5') && (
                                          <td className="text-left">{item.location_from_name ? item.location_from_name : '-'}</td>
                                       )
                                    }
                                    <td className="text-center text-primary bold">{parseFloat(item.quantity, 10) > 0 ? `${item.quantity} kgs.` : 0}</td>
                                    <td className="white-space-pre-wrap">{item.note ? item.note : '-'}</td>
                                    {
                                       this.userdata.type !== '4' && (
                                          <td>{item.batch_code ? item.batch_code : '-'}</td>
                                       )
                                    }
                                    <td className="text-center"><Badge color={badgeColor}>{returnStatus[item.status]}</Badge></td>
                                    {
                                       this.userdata.type !== '4' && (
                                          <>
                                          <td className="white-space-pre-wrap">{item.disposal_reason ? item.disposal_reason : '-'}</td>
                                          <td className="text-center">
                                             {
                                                item.status === 0 && (
                                                   <>
                                                      <Button color="primary" className="btn-xs" id={`mergebtn${i + 1}`} onClick={e => this.mergeToggle(e, item.stock_return_id, item.location_to, item.product_id)} outline><span className="fa fa-object-group" /></Button>
                                                      <UncontrolledTooltip placement="bottom" target={`mergebtn${i + 1}`}>Merge Stock To Batch</UncontrolledTooltip>
                                                      <Button color="danger" className="btn-xs" id={`disposebtn${i + 1}`} onClick={e => this.disposeToggle(e, item.stock_return_id)} outline><span className="fa fa-times" /></Button>
                                                      <UncontrolledTooltip placement="bottom" target={`disposebtn${i + 1}`}>Dispose</UncontrolledTooltip>
                                                   </>
                                                )
                                             }
                                          </td>
                                          </>
                                       )
                                    }
                                 </tr>
                              );
                           }) : (
                              <tr className="text-center">
                                 <td colSpan="9">No data available..</td>
                              </tr>
                           )
                        }
                     </tbody>
                  </Table>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(ReturnLists);
